<template>
  <v-container fluid class="panel">
    <v-layout row wrap>
      <v-flex xs11>
        <v-text-field append-icon="search" label="" :placeholder="$t('private_global.filter')" single-line hide-details v-model="search"></v-text-field>
      </v-flex>
      <v-flex xs1 text-xs-right>
        <v-btn color="primary" fab flat outline @click="loadData">
          <v-icon color="primary">mdi-refresh</v-icon>
        </v-btn>
      </v-flex>
      <v-flex xs12>
        <v-data-table :headers="headers" :items="bookings" :rows-per-page-text="$t('global_tables_rows_page')" :rows-per-page-items="rowsPerPageItems" :search="search">
          <template slot="items" slot-scope="props">
            <td>{{ props.item.id }}</td>
            <td>{{ props.item.typeText }}</td>
            <td>{{ props.item.customer }}</td>
            <td>{{ props.item.plate }}</td>
            <td v-if="parkingIsSensored">{{ props.item.spotText }}</td>
            <td>
              <v-chip :color="props.item.statusClass" outline :text-color="props.item.statusClass">{{ props.item.statusText }}</v-chip>
            </td>
            <td>
              {{ props.item.start | formatDateTimeLong }}
            </td>
          </template>
          <template slot="no-data">
            <v-alert :value="true" outline color="info" v-html="$t('private_dash_table_earnings_nodata')"> </v-alert>
          </template>
          <template slot="pageText" slot-scope="props">
            {{ props.pageStart }} - {{ props.pageStop }} {{ $t('global_table_from_of_preposition') }} {{ props.itemsLength }}
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import { EventBus } from '@/services/eventBus';
import reservationService from '@/services/reservationService';
import keys from '@/store/keys';
import _ from 'lodash';

export default {
  name: 'bookings-table-box',
  props: ['parkingId', 'parkingIsSensored'],
  data() {
    return {
      rowsPerPageItems: [25, 50, 100, { text: this.$i18n.t('row_pagination_all'), value: -1 }],
      bookings: [],
      search: '',
      headers: [
        {
          i18nText: 'private_parking_activity_spots_bookings_id',
          text: this.$i18n.t('private_parking_activity_spots_bookings_id'),
          align: 'left',
          value: 'id'
        },
        {
          i18nText: 'private_parking_activity_spots_bookings_type',
          text: this.$i18n.t('private_parking_activity_spots_bookings_type'),
          align: 'left',
          value: 'typeText'
        },
        {
          i18nText: 'private_parking_activity_events_access_user',
          text: this.$i18n.t('private_parking_activity_events_access_user'),
          align: 'left',
          value: 'customer'
        },
        {
          i18nText: 'private_parking_activity_events_access_plate',
          text: this.$i18n.t('private_parking_activity_events_access_plate'),
          align: 'left',
          value: 'plate'
        },
        {
          i18nText: 'private_parking_activity_spots_bookings_spot',
          text: this.$i18n.t('private_parking_activity_spots_bookings_spot'),
          align: 'left',
          value: 'spotText'
        },
        {
          i18nText: 'private_parking_activity_spots_bookings_status',
          text: this.$i18n.t('private_parking_activity_spots_bookings_status'),
          align: 'left',
          value: 'statusText'
        },
        {
          i18nText: 'private_parking_activity_spots_bookings_entry',
          text: this.$i18n.t('private_parking_activity_spots_bookings_entry'),
          align: 'left',
          value: 'start'
        }
      ]
    };
  },
  created() {
    EventBus.$on(keys.eventOnLanguageChanged, this.updateTableLables);
    this.loadData();

    if (this.parkingIsSensored) {
      this.headers = [
        {
          i18nText: 'private_parking_activity_spots_bookings_id',
          text: this.$i18n.t('private_parking_activity_spots_bookings_id'),
          align: 'left',
          value: 'id'
        },
        {
          i18nText: 'private_parking_activity_spots_bookings_type',
          text: this.$i18n.t('private_parking_activity_spots_bookings_type'),
          align: 'left',
          value: 'typeText'
        },
        {
          i18nText: 'private_parking_activity_events_access_user',
          text: this.$i18n.t('private_parking_activity_events_access_user'),
          align: 'left',
          value: 'customer'
        },
        {
          i18nText: 'private_parking_activity_events_access_plate',
          text: this.$i18n.t('private_parking_activity_events_access_plate'),
          align: 'left',
          value: 'plate'
        },
        {
          i18nText: 'private_parking_activity_spots_bookings_spot',
          text: this.$i18n.t('private_parking_activity_spots_bookings_spot'),
          align: 'left',
          value: 'spotText'
        },
        {
          i18nText: 'private_parking_activity_spots_bookings_status',
          text: this.$i18n.t('private_parking_activity_spots_bookings_status'),
          align: 'left',
          value: 'statusText'
        },
        {
          i18nText: 'private_parking_activity_spots_bookings_entry',
          text: this.$i18n.t('private_parking_activity_spots_bookings_entry'),
          align: 'left',
          value: 'start'
        }
      ];
    } else {
      this.headers = [
        {
          i18nText: 'private_parking_activity_spots_bookings_id',
          text: this.$i18n.t('private_parking_activity_spots_bookings_id'),
          align: 'left',
          value: 'id'
        },
        {
          i18nText: 'private_parking_activity_spots_bookings_type',
          text: this.$i18n.t('private_parking_activity_spots_bookings_type'),
          align: 'left',
          value: 'typeText'
        },
        {
          i18nText: 'private_parking_activity_events_access_user',
          text: this.$i18n.t('private_parking_activity_events_access_user'),
          align: 'left',
          value: 'customer'
        },
        {
          i18nText: 'private_parking_activity_events_access_plate',
          text: this.$i18n.t('private_parking_activity_events_access_plate'),
          align: 'left',
          value: 'plate'
        },
        {
          i18nText: 'private_parking_activity_spots_bookings_status',
          text: this.$i18n.t('private_parking_activity_spots_bookings_status'),
          align: 'left',
          value: 'statusText'
        },
        {
          i18nText: 'private_parking_activity_spots_bookings_entry',
          text: this.$i18n.t('private_parking_activity_spots_bookings_entry'),
          align: 'left',
          value: 'start'
        }
      ];
    }
  },
  destroyed() {
    EventBus.$off(keys.eventOnLanguageChanged, this.updateTableLables);
  },
  methods: {
    updateTableLables() {
      _.each(this.headers, itHeaders => {
        itHeaders.text = this.$i18n.t(itHeaders.i18nText);
      });
    },
    loadData() {
      let params = {
        parking: this.parkingId
      };
      reservationService.ongoing(params, this.ongoingSuccessHandler, this.ongoingErrorHandler);
    },
    ongoingSuccessHandler(data) {
      this.bookingsFromData = [];
      this.bookingsFromData = data;
      this.updateBookingStatusText();
    },
    ongoingErrorHandler() {},
    updateBookingStatusText() {
      this.bookings = [];
      this.$nextTick(() => {
        this.bookings = this.bookingsFromData;
        _.each(this.bookingsFromData, booking => {
          switch (booking.status) {
            case 'ACCEPTED':
              booking.statusClass = 'blue';
              booking.statusText = this.$i18n.t('private_parking_activity_spots_bookings_status_1');
              break;
            case 'IN_USE':
              booking.statusClass = 'green';
              booking.statusText = this.$i18n.t('private_parking_activity_spots_bookings_status_2');
              break;
            default:
              booking.statusClass = 'red';
              booking.statusText = '-';
              break;
          }
          booking.spotText = '-';
          if (booking.spot) {
            booking.spotText = booking.spot;
          }
          booking.typeText = this.$i18n.t('private_parking_activity_spots_bookings_type_2');
          if (booking.type === 'BOOKING') {
            booking.typeText = this.$i18n.t('private_parking_activity_spots_bookings_type_1');
          }
        });
      });
    }
  }
};
</script>

<style lang="scss" scoped>
h1.table-title,
.panel .panel-heading .panel-title {
  font-size: 16px;
  font-weight: 400;
  margin-bottom: 0;
  color: #000;
}
</style>



// WEBPACK FOOTER //
// src/components/commons/BookingsTableBox.vue